import { searchForContractParty } from "@/api/contract-party.service";

export const useContractPartySearch = () => {
  const itemTitle = i => {
    let title = i.name || [i.firstName, i.lastName].filter(Boolean).join(" ");

    if (i.lastFour) {
      title = `${title} (${i.lastFour})`;
    }
    return title;
  };

  return {
    itemTitle,
    comparisonValue: v => v?.id,
    fetchResults: async v => {
      const res = await searchForContractParty(v);
      return res.toSorted((a, b) => itemTitle(a).localeCompare(itemTitle(b)));
    }
  };
};
